import type { PublicSiteLocaleOverride } from '../publicSiteTypes'

export const frPublicSiteOverride = {
  content: {
    brand: {
      tagline: 'Des plans vivants, jamais figés',
    },
    routes: [
      { label: 'Aperçu', title: 'The Timelining App', description: 'Un espace de planification visuelle avec crédits, revue IA et boucle RPG pour garder les plans vivants.' },
      { label: 'Solutions', title: 'Solutions', description: 'Flux réels : lancements, agences, créateurs, étudiants, terrain et cohortes.' },
      { label: 'Guide', title: 'Guide', description: 'Le parcours complet : de l’espace vide au plan livré, avec chaque surface, rôle et cérémonie.' },
      { label: 'Ressources', title: 'Ressources', description: 'Modèles prêts à copier, prompts IA, templates de checklist et cadences.' },
      { label: 'Tarifs', title: 'Tarifs', description: 'Tarifs par crédits. Payez ce que vous consommez, pas les sièges.' },
      { label: 'Télécharger', title: 'Télécharger', description: 'Installez les apps Android Member et Helper depuis la page publique.' },
      { label: 'À propos', title: 'À propos', description: 'Pourquoi cette app existe, ce qu’elle défend, ce qui est livré et ce qui arrive.' },
      { label: 'FAQ', title: 'FAQ', description: '25 questions sur la configuration, l’IA, la gamification, les équipes et les données.' },
      { label: 'Contact', title: 'Contact', description: 'Contact pour pilotes, support, retours, démonstrations et presse.' },
    ],
    hero: {
      eyebrow: 'Planification visuelle · crédits · revue IA',
      headline: 'Des plans vivants, jamais figés',
      accent: 'vivants',
      primaryCtaSignedOut: 'Lancer l’app',
      primaryCtaSignedIn: 'Ouvrir mon espace',
      secondaryCta: 'Lire le guide',
      consoleNoteSignedOut: 'La connexion ouvre l’expérience privée.',
      consoleNoteSignedIn: 'Vous êtes connecté. Continuez depuis votre espace.',
    },
    ctaBand: {
      eyebrow: 'Prêt ?',
      title: 'Ouvrez la Console. Ou prenez l’app.',
      primary: 'Ouvrir Console',
      secondary: 'Obtenir les APK',
    },
  },
  chrome: {
    nav: {
      ariaLabel: 'Navigation publique',
      brandHomeSuffix: 'accueil',
      contact: 'Contact',
      getStarted: 'Commencer',
      languageLabel: 'Langue',
      languageAriaLabel: 'Langue du site',
    },
    common: {
      openWorkspace: 'Ouvrir mon espace',
      openConsole: 'Ouvrir Console',
      featureColumnHeader: 'Fonction',
      capabilityColumnHeader: 'Capacité',
    },
    download: {
      eyebrow: 'Obtenir Timelining',
      title: 'Installez les apps Android.',
      downloadApk: 'Télécharger APK',
      copyLink: 'Copier lien',
      share: 'Partager',
    },
  },
} satisfies PublicSiteLocaleOverride
